import { atom } from "recoil";

export const noticeState = atom<boolean>({
  key: "notice",
  default: false,
});

export const unreadCountState = atom<number>({
  key: "unreadCount",
  default: 0,
});
